<ng-container ngModelGroup="timeGroup" #time="ngModelGroup">
  <app-filter-item title="Daily time range" [value]="timeRange" [clearFilter]="clearFilter">
    <div class="time-filter__inputs">
      <mat-form-field appearance="outline">
        <mat-select name="hoursFrom"
          #hoursFrom
          placeholder="hh"
          [(ngModel)]="timeGroup.hoursFrom"
          (ngModelChange)="onFromHourChange()"
        >
          <mat-option *ngFor="let hour of hours" [value]="hour">
            {{hour}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-select name="minutesFrom"
          #minutesFrom
          placeholder="mm"
          [(ngModel)]="timeGroup.minutesFrom"
          (ngModelChange)="onFromMinuteChange()"
        >
          <mat-option *ngFor="let minute of minutes" [value]="minute">
            {{minute}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-select name="hoursTo"
          #hoursTo
          placeholder="hh"
          [(ngModel)]="timeGroup.hoursTo"
          (ngModelChange)="onToHourChange($event)"
        >
          <mat-option *ngFor="let hour of hours" [value]="hour">
            {{hour}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-select name="minutesTo"
          #minutesTo
          placeholder="mm"
          [(ngModel)]="timeGroup.minutesTo"
          (ngModelChange)="onToMinuteChange()"
        >
          <mat-option *ngFor="let minute of minutes" [value]="minute">
            {{minute}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-button-toggle-group
      name="dayNight"
      [(ngModel)]="selectedDayNight"
      (ngModelChange)="onDayNightChange()"
      class="time-filter__day-night-buttons"
    >
      <mat-button-toggle *ngFor="let item of dayNightOptions;" [value]="item.value">
        {{ item.viewValue }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </app-filter-item>
</ng-container>
